import { OverviewContentWrapper } from "./OverviewContentWrapper";

export const RegisOverviewContent = () => {
  return (
    <OverviewContentWrapper>
      <h3>{"Features of REGIS MB Chat"}</h3>
      <p>
        This new artificial intelligence-based solution will support you in
        understanding lengthy complex legislation documents, by allowing you to
        get instant, accurate, and contextually relevant responses to a wide
        range of queries around the current regulation landscape, making it a
        valuable tool for information retrieval and decision-making support.
      </p>
      <h3>{"Limitations"}</h3>
      <p>
        The knowledge base only has access to a document corpus containing over
        60 EU regulations and German law documents. There is no access to
        information on the Internet or any other tool. For a full document list,
        please contact Mateo Garzon Rivera Mateo Garzon Rivera (
        <a href="mailto: mateo.garzonrivera@mabanaft.com?subject=Mabachat%20REGIS%20Feedback">
          mateo.garzonrivera@mabanaft.com
        </a>
        ).
      </p>
      <h3>{"Best Practices"}</h3>
      <p>
        Keep queries concise and specific. For broader queries, the chatbot may
        provide a list of options.
      </p>
    </OverviewContentWrapper>
  );
};
